import {JobDetailDto} from '../../api/generated/index.defs.ts';

export const useJobCrumbs = (job: JobDetailDto | undefined) => ({
  levelOfServiceDescription: `${job?.levelOfServiceDescription}`,
  status: `${job?.status}`,
  serialNumber: `${job?.serialNumber?.replace(/^0+/, '')}`,
  isRepairable: `${job?.evaluationIsRepairable ? 'Yes' : job?.evaluationIsRepairable === null ? 'Unk' : 'No'}`,
  quoteStatus: `${job?.evaluationQuoteStatus ?? ''}`,
  reviewStatus: `${job?.reviewStatus ?? ''}`,
  partNumber: `${job?.partNumber ?? ''}`,
  clientName: `${job?.clientName}`,
  assetNumber: `${job?.assetNumber}`,
});